export function startProgressIndicator() {
  getOverlay().classList.remove('hidden');
}

export function stopProgressIndicator() {
  getOverlay().classList.add('hidden');
}

// Template should contain '{numerator}', '{denominator}' and/or '{percentage}' placeholders.
export function setProgress(numerator, denominator, singularTemplate, pluralTemplate) {
  const percentage = (denominator === 0 ? 0 : Math.ceil(numerator * 100 / denominator));
  const template = (denominator === 1 ? singularTemplate : pluralTemplate);
  const messageWrapper = getMessageWrapper();
  messageWrapper.innerText = template
    .replace('{numerator}', numerator)
    .replace('{denominator}', denominator)
    .replace('{percentage}', `${percentage}%`);
}

function getOverlay() {
  return document.getElementById('progress-overlay');
}

function getMessageWrapper() {
  return document.getElementById('progress-overlay-message');
}
